// extracted by mini-css-extract-plugin
module.exports = {"profile":"SubMenu_profile__3S4nY","active":"SubMenu_active__3lknJ","disable":"SubMenu_disable__2f6o9"};